// extracted by mini-css-extract-plugin
module.exports = {"root":"StatsCard_root__2OoOC","value":"StatsCard_value__1dG_P","footer":"StatsCard_footer__CK3KF","trend":"StatsCard_trend__oj__w","trend__icon":"StatsCard_trend__icon__1axZh"};